import { FC, ReactElement } from 'react';
import style from './Tabs.module.scss';

type TabItem = {
  id: string;
  title: string;
  component: ReactElement;
};

interface TabsProps {
  items: TabItem[];
  activeItem: string;
  onItemSelect: (index: string) => void;
}

const Tabs: FC<TabsProps> = ({ items, activeItem, onItemSelect }) => {
  const activeItemIndex = items.findIndex((item) => item.id === activeItem);
  return (
    <div className="h-full">
      <ul className={style.tabs__list__items}>
        {items?.map((item: TabItem) => (
          <li
            key={item.id}
            className={`${style.tabs__list__item} ${
              item.id === activeItem ? style.tabs__list__item__active : ''
            }`}
            onClick={() => onItemSelect(item.id)}
          >
            {item.title}
          </li>
        ))}
      </ul>
      <div className={style.tabs__content}>
        {activeItemIndex > -1 && items[activeItemIndex].component}
      </div>
    </div>
  );
};

export default Tabs;
